import { render, staticRenderFns } from "./whats-included.vue?vue&type=template&id=73fc9976&"
import script from "./whats-included.vue?vue&type=script&lang=js&"
export * from "./whats-included.vue?vue&type=script&lang=js&"
import style0 from "./whats-included.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports